export class OrdenModel {
    documento?: string;
    tipo_documento?: string;
    obligacion?: string;
    valor_pagado?: string;
    id_pais?: string;
  }
  